import { z } from 'zod';
import { Employee } from '@/api/apis/resources';
import { RegionHub } from '@/api/apis/facilities';

export const regionFormSchema = z.object({
  name: z.string().min(1, 'Provide region name'),
  nationalManagers: z.array(z.custom<Employee>()).min(1, 'Provide national manager'),
  regionalManagers: z.array(z.custom<Employee>()).min(1, 'Provide regional manager'),
  hubs: z.array(z.custom<RegionHub>()).min(1, 'Provide hub'),
});
